import { inject, Injectable, signal } from '@angular/core';
import { SimpleApi } from '@core/api/simple.api';
import { BatchJobScheduleSearchParams } from './batch-job-schedule/batch-job-schedule-search-params.model';
import { BatchJobScheduleDatasource } from './batch-job-schedule/batch-job-schedule.datasource';
import { BatchJobSchedule } from './batch-job-schedule/batch-job-schedule.model';
import { BatchJobStatusDatasource } from './batch-job-status/batch-job-status.datasource';
import { BatchJobSearchParams } from './batch-job/batch-job-search-params.model';
import { BatchJobDatasource } from './batch-job/batch-job.datasource';
import { BatchJob } from './batch-job/batch-job.model';
import { AuthService } from '@core/auth/auth.service';
import { RettighedsType } from '@core/auth/rettighed.model';

@Injectable({
  providedIn: 'root',
})
export class BatchService {
  authService = inject(AuthService);
  simpleApi = inject(SimpleApi);

  batchJobDatasource = inject(BatchJobDatasource);
  batchJobSceduleDatasource = inject(BatchJobScheduleDatasource);
  batchJobStatusDatasource = inject(BatchJobStatusDatasource);

  selectedBatchJob = signal<BatchJob | undefined>(undefined);
  selectedBatchJobSchedule = signal<BatchJobSchedule | undefined>(undefined);

  batchJobFirstRecord = signal(0);

  searchBatchJob(searchParams: BatchJobSearchParams) {
    this.batchJobFirstRecord.set(0);
    this.selectedBatchJob.set(undefined);
    this.batchJobDatasource.searchParams.set(searchParams);
    this.batchJobDatasource.loadData();
  }

  searchBatchJobSchedule(searchParams: BatchJobScheduleSearchParams) {
    this.selectedBatchJobSchedule.set(undefined);
    this.batchJobSceduleDatasource.searchParams.set(searchParams);
    this.batchJobSceduleDatasource.loadData();
  }

  async refreshData() {
    this.batchJobStatusDatasource.searchParams.set({
      status: ['Waiting', 'Running', 'Completed'],
    });
    this.batchJobStatusDatasource.loadData();
    this.batchJobDatasource.loadData();
    this.batchJobSceduleDatasource.loadData();
  }

  async afbrydJob(batchJob: BatchJob) {
    const response = await this.simpleApi.create(
      '/api/admin/batchjobs/afbryd',
      batchJob
    );
    console.log(response);
  }

  async genstartJob(batchJob: BatchJob) {
    await this.simpleApi.create('/api/admin/batchjobs/genstart', batchJob);
  }

  allowWrite() {
    return this.authService.hasRettighed(RettighedsType.AdminBatchSkriv);
  }
}
